<app-side-menu>
  <div class="contracts-container">
    <!-- Header -->
    <div class="header">
      <div class="header-content">
        <div class="title-section">
          <i class="fa-solid fa-file-contract"></i>
          <h1>Contratos</h1>
        </div>
        <div class="header-actions">
          <button *appHasPermission="'Contracts.Create'" class="btn-primary" (click)="navigateToNewContract()">
            <i class="fa-solid fa-plus"></i>
            Novo Contrato
          </button>
        </div>
      </div>
      <p>Sistema automatizado de geração e gerenciamento de contratos.</p>
    </div>

    <!-- Stats Section -->
    <div class="stats-section">
      <div class="stat-card">
        <div class="stat-icon">
          <i class="fa-solid fa-file-contract"></i>
        </div>
        <div class="stat-content">
          <h3>{{ totalContractsCount }}</h3>
          <p>Total de Contratos</p>
        </div>
      </div>
      <div class="stat-card success">
        <div class="stat-icon active">
          <i class="fa-solid fa-circle-check"></i>
        </div>
        <div class="stat-content">
          <h3>{{ activeContractsCount }}</h3>
          <p>Contratos Ativos / Vigentes</p>
          <small>Sem irregularidades</small>
        </div>
      </div>
      <div class="stat-card warning">
        <div class="stat-icon pending">
          <i class="fa-solid fa-clock"></i>
        </div>
        <div class="stat-content">
          <h3>{{ pendingContractsCount }}</h3>
          <p>Pendentes</p>
          <small>Com irregularidades</small>
        </div>
      </div>
      <div class="stat-card warning-orange">
        <div class="stat-icon">
          <i class="fa-solid fa-clock-rotate-left"></i>
        </div>
        <div class="stat-content">
          <h3>{{ nearExpirationContractsCount }}</h3>
          <p>Próximos ao Vencimento</p>
          <small>Menos de 3 dias</small>
        </div>
      </div>
      <div class="stat-card danger">
        <div class="stat-icon">
          <i class="fa-solid fa-ban"></i>
        </div>
        <div class="stat-content">
          <h3>{{ expiredContractsCount }}</h3>
          <p>Expirados</p>
          <small>Vencidos</small>
        </div>
      </div>
    </div>

    <!-- Filtros Avançados -->
    <div class="filters-section">
      <div class="row g-3">
        <div class="col-md-6">
          <div class="filter-group">
            <label for="searchTerm">Busca Livre:</label>
            <input
              type="text"
              id="searchTerm"
              [(ngModel)]="searchTerm"
              (ngModelChange)="onSearchChange()"
              placeholder="Buscar por nome, CPF, placa, modelo, marca, ID..."
              class="form-control">
          </div>
        </div>

        <div class="col-md-6">
          <div class="filter-group">
            <label for="selectedStatus">Status:</label>
            <select
              id="selectedStatus"
              [(ngModel)]="selectedStatus"
              (ngModelChange)="onStatusChange()"
              class="form-control">
              <option *ngFor="let option of statusOptions" [value]="option.value">
                {{option.label}}
              </option>
            </select>
          </div>
        </div>
      </div>


    </div>

    <!-- Generic Table with Dropdown Menu (paginação no backend) -->
    <div class="table-container">
      <app-table
        [title]="'Lista de Contratos'"
        [data]="contracts"
        [columns]="tableColumns"
        [loading]="isLoading"
        [showSearch]="false"
        [actions]="tableActions"
        [visibleActions]="visibleActions"
        [useDropdownMenu]="true"
        [clickable]="false"
        [totalItemsFromBackend]="totalCount"
        [currentPageFromBackend]="currentPage"
        [itemsPerPage]="pageSize"
        [hasNextPageFromBackend]="currentPage < totalPages"
        [hasPreviousPageFromBackend]="currentPage > 1"
        [enableSorting]="true"
        (actionClick)="onTableAction($event)"
        (rowClick)="onRowClick($event)"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        (sortChange)="onSortChange($event)">
        <app-button
          table-header-action
          text="Exportar CSV"
          [color]="'var(--success-color, #16a34a)'"
          [height]="'42px'"
          className="export-btn"
          (buttonClick)="exportToCSV()">
        </app-button>
      </app-table>
    </div>

    <!-- Empty State -->
    <div *ngIf="contracts.length === 0 && !isLoading" class="empty-state">
      <i class="fa-solid fa-file-contract"></i>
      <h3>Nenhum contrato encontrado</h3>
      <p>Crie seu primeiro contrato para começar</p>
      <button *appHasPermission="'Contracts.Create'" class="btn-primary" (click)="navigateToNewContract()">
        <i class="fa-solid fa-plus"></i>
        Criar Primeiro Contrato
      </button>
    </div>

    <!-- Modal de cancelamento (estilo referência) -->
    <div
      *ngIf="showCancelModal"
      class="ccm-backdrop"
      (click)="onCancelModalBackdropClick($event)"
      tabindex="-1"
      role="presentation">
      <div
        class="ccm-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ccm-title"
        (click)="$event.stopPropagation()">
        <header class="ccm-header">
          <div class="ccm-header-title-wrap">
            <div class="ccm-icon-ban" aria-hidden="true">
              <i class="fas fa-ban"></i>
            </div>
            <h3 id="ccm-title" class="ccm-title">Cancelar contrato</h3>
          </div>
          <button
            type="button"
            class="ccm-close"
            (click)="closeCancelModal()"
            [disabled]="isLoading"
            aria-label="Fechar">
            <i class="fas fa-times"></i>
          </button>
        </header>

        <div class="ccm-body">
          <div class="ccm-alert-attention">
            <i class="fas fa-exclamation-triangle ccm-alert-icon" aria-hidden="true"></i>
            <div class="ccm-alert-content">
              <h4 class="ccm-alert-heading">Atenção necessária</h4>
              <p class="ccm-alert-lead">
                Antes de prosseguir, certifique-se de que o cliente cumpriu os seguintes requisitos:
              </p>
              <ul class="ccm-checklist">
                <li><span class="ccm-bullet"></span> Verifique se há pagamentos pendentes</li>
                <li><span class="ccm-bullet"></span> Confirme se há multas ou pendências</li>
                <li><span class="ccm-bullet"></span> Verifique se o veículo foi devolvido em bom estado</li>
              </ul>
            </div>
          </div>

          <div class="ccm-form-block">
            <label class="ccm-label" for="cancelReasonCode">
              Motivo do cancelamento <span class="ccm-req">*</span>
            </label>
            <div class="ccm-select-wrap">
              <select
                id="cancelReasonCode"
                class="ccm-select"
                [(ngModel)]="cancelReasonCode"
                name="cancelReasonCode">
                <option [ngValue]="''" disabled>Selecione um motivo…</option>
                <option *ngFor="let o of contractCancelReasonOptions" [ngValue]="o.code">{{ o.label }}</option>
              </select>
              <span class="ccm-select-chevron" aria-hidden="true"><i class="fas fa-chevron-down"></i></span>
            </div>
            <p class="ccm-hint">
              <i class="fas fa-info-circle"></i>
              Este motivo será registrado permanentemente para auditoria.
            </p>
          </div>

          <div class="ccm-confirm-box">
            <p class="ccm-confirm-text">
              Deseja realmente confirmar o cancelamento do contrato
              <span class="ccm-contract-id">#{{ getContractNumber() }}</span>?
            </p>
          </div>
        </div>

        <footer class="ccm-footer">
          <button type="button" class="ccm-btn ccm-btn-back" (click)="closeCancelModal()" [disabled]="isLoading">
            <i class="fas fa-times"></i>
            Voltar
          </button>
          <button
            type="button"
            class="ccm-btn ccm-btn-danger"
            (click)="confirmCancelContract()"
            [disabled]="!canSubmitContractCancel()">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm ccm-spinner" role="status"></span>
            <i *ngIf="!isLoading" class="fas fa-trash-alt" aria-hidden="true"></i>
            {{ isLoading ? 'Cancelando…' : 'Confirmar cancelamento' }}
          </button>
        </footer>
      </div>
    </div>

    <app-contract-freeze-modal
      [isOpen]="showFreezeModal"
      [contractId]="contractFreezeId"
      [subtitle]="contractFreezeSubtitle"
      (closed)="closeFreezeModal()"
      (frozen)="onContractFrozen($event)">
    </app-contract-freeze-modal>
  </div>
</app-side-menu>
